<template>
    <div>
        <form @submit.prevent="subscribe">
            <div class="flex py-2">
                <!-- name -->
                <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full md:w-6/12 md:pr-2">
                    <label>
                        <span class="text-gray-700">Nome<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Il tuo nome" v-model="form.name" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
                <!-- surname -->
                <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full md:w-6/12 md:pl-2">
                    <label>
                        <span class="text-gray-700">Cognome<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Il tuo cognome" v-model="form.last_name" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex py-2">
                <ValidationProvider name="email" rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                <label>
                    <span class="text-gray-700">Email<span class="text-red-600">*</span></span>
                    <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded" type="email" placeholder="Email" v-model="form.email" required>
                </label>
                <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="w-full mt-4">
                <ValidationProvider name="phone" rules="required" :bails="false" v-slot="{ errors}">
                    <span class="text-gray-700">Cellulare<span class="text-red-600">*</span></span>
                    <div class="flex">
                        <div>
                            <vue-country-code
                                @onSelect="onSelect"
                                :onlyCountries="['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE', 'GR','HU','IE','IT','LV','LT','LU','MT','MD','NL','PL','PT','RO','RS','SK','SI','ES','SE','UA', 'CH']"
                                :defaultCountry="'IT'"
                            >
                            </vue-country-code>
                        </div>
                        <div>
                            <input class="block w-full p-3 border border-gray-300 border-solid rounded-r " minlength="9" maxlength="10" type="text" v-on:keypress="NumbersOnly" placeholder="1234567891" v-model="form.phone" required>
                        </div>
                    </div>
                    <span class="text-xs font-bold error-notice">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <!-- street address -->
            <div class="flex py-2">
                <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Indirizzo<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Indirizzo" v-model="form.address" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex py-2">
                <!-- city -->
                <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Città<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Città" v-model="form.city" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
    
                <!--nation-->
    
                <div class="flex py-2">
                    <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                        class="block w-full md:w-12/12">
                        <label>
                            <span class="text-gray-700">Paese<span class="text-red-600">*</span></span>
                            <select class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded"
                                v-model="form.selectedCountry">
                                <option value="" disabled>Select a country</option>
                                <option v-for="(country, code) in countries" :key="code"
                                    :value="`${country.name} (${code})`">
                                    {{ country.name }} ({{ code }})
                                </option>
                            </select> </label>
                        <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
    
    
                <div class="flex py-2" v-if="form.selectedCountry == 'Italy (IT)'">
                    <ValidationProvider name="region" rules="required" :bails="false" v-slot="{ errors }"
                        class="block w-full md:w-12/12">
                        <label>
                            <span class="text-gray-700">Regione<span class="text-red-600">*</span></span>
                            <select v-model="form.region"
                                class="block w-full px-2 py-3 pr-8 bg-white border border-gray-300 rounded shadow appearance-none hover:border-gray-400 focus:shadow-outline">
                                <option value="" selected hidden disabled>Seleziona Regione</option>
                                <option v-for="region in allregions" :key="region.id" :value="region.id">{{ region.name }}
                                </option>
                            </select>
                        </label>
                        <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
    
                <!-- province -->
                <div class="flex py-2">
    
                <ValidationProvider name="province" v-if="form.selectedCountry == 'Italy (IT)'" rules="required" :bails="false" v-slot="{ errors}" class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Provincia<span class="text-red-600">*</span></span>
                        <select v-model="form.province" class="block w-full px-2 py-3 pr-8 bg-white border border-gray-300 rounded shadow appearance-none hover:border-gray-400 focus:shadow-outline">
                            <option value="" selected hidden disabled>Seleziona Provincia</option>
                            <option v-for="province in provinces" :key="province.id" :value="province.id" v-if="province.region_id == form.region">{{ province.name }}</option>
                        </select>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
    
            <div class="flex py-2">
                <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full md:w-12/12 md:pr-2">
                    <label>
                        <span class="text-gray-700">Azienda<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Azienda" v-model="form.company" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex py-2">
                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                        class="block w-full md:w-12/12">
                        <label>
                            <span class="text-gray-700">Ruolo<span class="text-red-600">*</span></span>
                            <select v-model="form.job_role"
                                class="block w-full px-2 py-3 pr-8 bg-white border border-gray-300 rounded shadow appearance-none hover:border-gray-400 focus:shadow-outline">
    
                                <option value="" selected hidden disabled>Seleziona Ruolo</option>
                                <option v-for="role in jobroles" :key="role.id" :value="role.id">{{ role.name }}</option>
                            </select>
                        </label>
                        <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
            </div>
                <div class="py-2">
                <label class="flex items-center space-x-2 text-gray-700">
                    <input type="checkbox" v-model="useSameAddress">
                    <span>Utilizza i dati di registrazione</span>
                </label>
            </div>
            <div class="py-2">
                <h1 class="text-gray-700">Fattura<span class="text-red-600">*</span></h1>
                <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                    <div class="flex justify-between">
                        <div>
                            <label for="invoice_type">
                                <input type="radio" name="invoice_type" id="person" value= 1 v-model="form.invoice_type">
                                <span>Persona</span>
                            </label>
                        </div>
                        <div>
                            <label for="invoice_type">
                                <input type="radio" name="invoice_type" id="company" value= 2 v-model="form.invoice_type">
                                <span>Azienda</span>
                            </label>
                        </div>
                    </div>
                    <!-- <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Azienda" v-model="form.company" required> -->
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div>
                <div v-if="form.invoice_type == 1">
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                    <label>
                        <span class="text-gray-700">Codice fiscale<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Codice Fiscale" v-model="form.fiscal_code" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                        <label>
                            <span class="text-gray-700">Indirizzo di fatturazione<span class="text-red-600">*</span></span>
                            <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Indirizzo" v-model="form.fiscal_address" required>
                        </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                        <label>
                            <span class="text-gray-700">Città<span class="text-red-600">*</span></span>
                            <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Città" v-model="form.fiscal_city" required>
                        </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                        <label>
                            <span class="text-gray-700">CAP<span class="text-red-600">*</span></span>
                            <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="number" placeholder="CAP" v-model="form.fiscal_zipcode" required>
                        </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
    
                <div v-if="form.invoice_type == 2" class="py-2">
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                    <label>
                        <span class="text-gray-700">P.IVA<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Partita IVA" v-model="form.vat_number" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
    
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                    <label>
                        <span class="text-gray-700">Codice SDI<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="SDI" v-model="form.sd_code" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                    
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                        <label>
                            <span class="text-gray-700">Indirizzo di fatturazione<span class="text-red-600">*</span></span>
                            <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Indirizzo" v-model="form.fiscal_address" required>
                        </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                        <label>
                            <span class="text-gray-700">Città<span class="text-red-600">*</span></span>
                            <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="text" placeholder="Città" v-model="form.fiscal_city" required>
                        </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider rules="required" :bails="false" v-slot="{ errors}" class="block w-full">
                        <label>
                            <span class="text-gray-700">CAP<span class="text-red-600">*</span></span>
                            <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded " type="number" placeholder="CAP" v-model="form.fiscal_zipcode" required>
                        </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="flex justify-start w-full pt-4">
                <ValidationProvider rules="required|exact_length:1" :bails="false" v-slot="{ errors}" class="items-center">
                <label>
                    <input type="checkbox" v-model="form.price" required>
                    <span class="ml-2">Ticket (€{{ event.raw_price }}  + 22% IVA)</span>
                </label><br>
                <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex justify-start w-full pt-4">
                <ValidationProvider rules="required|exact_length:1" :bails="false" v-slot="{ errors}" class="items-center">
                <label>
                    <input type="checkbox" v-model="form.privacy" required>
                    <span class="ml-2 text-xs">Dichiaro di aver ricevuto, letto e compreso l'<a href="https://eventiosm.it/privacy-policy" target="blank" class="font-semibold text-pink-600 hover:underline">informativa</a> ai sensi del Reg. UE 2016/679 (Art. 13) e presto il consenso al trattamento dei miei dati personali.</span>
                </label><br>
                <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
             <div v-if="reservationCount >= event.seats">
                <button v-if="message == '' " :disabled="!isComplete" type="submit" @click="showOk = true" class="w-full px-4 py-2 font-semibold text-center text-white uppercase bg-blue-500 rounded-md">subscribe</button>
            </div>
        </form> 
        <!-- modal -->
        <div v-if="reservationCount < event.seats" :disabled="!isComplete" :class="isComplete ? '' : 'opacity-50 cursor-not-allowed'" class="my-2">
            <PaymentModalComponent :formData="form" :event="event"></PaymentModalComponent>
        </div>
        <div>
            <p v-if="message != ''" class="px-2 py-3 text-lg font-semibold text-green-500 bre">{{ message }}</p>
        </div>                  
    </div>
    </template>
    
    <script>
    import axios from "axios";
    import { ValidationProvider } from 'vee-validate';
    import "../vee-validate.js";
    import PaymentModalComponent from '../Components/gateway/PaymentModalComponent.vue';
    import VueCountryCode from "vue-country-code";
    import { countries } from "countries-list";
    
    export default {
        components: {
            ValidationProvider,
            PaymentModalComponent,
            VueCountryCode,
        },
        props: ['event', 'provinces', 'reservationCount','jobroles','allregions'],
        data() {
            return {
                dataUrl: '',
                showOk: false,
                qrcode: null,
                reservation: [],
                message: '',
                code: '',
                useSameAddress:true,
                countries: countries, // Get the list of countries from the package
                form: {
                    email: '',
                    name: '',
                    last_name: '',
                    phone: '',
                    company: '',
                    company_role: '',
                    address: '',
                    city: this.city,
                    privacy: '',
                    price: 0,
                    invoice_type: null,
                    fiscal_code: null,
                    vat_number: null,
                    sd_code: null,
                    fiscal_address:'',
                    fiscal_zipcode:'',
                    fiscal_city:'',
                    province: '',
                    selectedCountry: "Italy (IT)",
                    region: '',
                    job_role: ''
                },
            };
        },
        computed: {
            isComplete () {
                const isItaly = this.form.selectedCountry === "Italy (IT)";
                if (this.form.invoice_type == 1) {
                    this.form.vat_number = null;
                    this.form.sd_code = null;
                     return this.form.email && this.form.name && this.form.last_name && this.form.phone && this.form.city 
                       && this.form.privacy && this.form.price && this.form.invoice_type && this.form.fiscal_code  && this.form.company
                     && this.form.address &&  this.form.selectedCountry && this.form.job_role &&
                     (!isItaly || (this.form.region && this.form.province)); 
                } else if(this.form.invoice_type == 2) {
                    this.form.fiscal_code = null;
                    return this.form.email && this.form.name && this.form.last_name && this.form.phone && this.form.city   && this.form.privacy 
                     && this.form.price && this.form.invoice_type && this.form.vat_number && this.form.sd_code && this.form.company
                    && this.form.fiscal_zipcode && this.form.fiscal_city && this.form.job_role && this.form.fiscal_address && this.form.address && this.form.selectedCountry &&
                    (!isItaly || (this.form.region && this.form.province));; 
                }
            }
        },
        watch: {
            'form.city'(newValue) {
          // Update fiscal_city only if checkbox is checked
          if (this.useSameAddress) {
            this.form.fiscal_city = newValue;
          }
        },
        'form.address'(newValue) {
          // Update fiscal_city only if checkbox is checked
          if (this.useSameAddress) {
            this.form.fiscal_address = newValue;
          }
        },
        useSameAddress(newValue) {
          if (newValue) {
            // When checked, set fiscal_city same as city
            this.form.fiscal_city = this.form.city;
            this.form.fiscal_address = this.form.address;
          } else {
            // When unchecked, clear fiscal_city
            this.form.fiscal_city = '';
            this.form.fiscal_address = '';

          }
        }
     },
        methods: {
            onSelect({iso2}) {
                this.code = iso2;
            },
            subscribe(e) {
                let custObj = this;
                e.preventDefault();
                axios.post('/api/store/contact', {
                    type: 1,
                    email: this.form.email,
                    name: this.form.name,
                    last_name:this.form.last_name,
                    phone: this.form.phone,
                    company: this.form.company,
                    city: this.form.city,
                    role: this.form.job_role,
                    province: this.form.province,
                    region: this.form.region,
                    nation: this.form.selectedCountry,
                    event: this.event.id,
                    invoice_type: this.form.invoice_type,
                    fiscal_code: this.form.fiscal_code,
                    vat_number: this.form.vat_number,
                    sd_code: this.form.sd_code,
                    address: this.form.address,
                    mode: null,
                    fiscal_address:this.form.fiscal_address,
                    fiscal_zipcode:this.form.fiscal_zipcode,
                    fiscal_city:this.form.fiscal_city,
    
                }).then(function (response) {
                     if (response.data.message ) {
                        axios.post('/api/extra-reservation/contact', {
                            reservation: response.data.reservation,
                        }).then(function (response) { 
                            custObj.message = response.data.code;
                        }).catch(function (error) {
                            console.log(error);
                        });                    
                    } else {
                        custObj.message = response.data.code;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            NumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return false;
                }
            }
        },
    }
    </script>
    
    <style lang="scss" scoped>
        input:valid {
            border-color: #10b981;
            background-color: #deeee9;
        }
        button[disabled] {
            opacity: 0.35;
        }
        input[type=radio]{
            margin-right: 8px;
        }
        .select select.changed, .input.changed {
            border: 2px solid #7ED321;
        }
        .select select.passed, .input.passed {
            border: 2px solid #7ED321;
            background: rgb(214, 238, 188);
        }
        .set{
            text-align: -webkit-center;
        }
        #preload {
            margin-top:17%;
            height:30px;
            width:30px;
            border-radius: 50%;
            border:5px solid #e5e5e5;
            animation:3s pre linear infinite;
        }
        @keyframes pre {
            0%{
                transform:rotate(0deg);
                border-top:5px solid mediumseagreen;
            }
            100%{
                transform:rotate(360deg);
                border-top:5px solid green;
            }
        }
        .vue-country-select {
            border-right: 0px;
            border-top: 1px solid #d1d5db;
            border-bottom: 1px solid #d1d5db;
            border-left: 1px solid #d1d5db;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            background: white;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            height: 3.1rem;
        }
    
    </style>